import React from "react";
import cx from "classnames";
const RegularButtons = (props: any) => {
    const {title, classname, clicked, style, disabled, focus, index, hover, leave} = props;
    return (
        <button disabled={disabled} onMouseMove={hover} onMouseLeave={leave}  tabIndex={index} autoFocus={focus} className={cx(classname)} onClick={clicked} style={style}>{title}</button>
    )
}
export default RegularButtons;
